/* eslint-disable no-inner-declarations */
import { DatabaseAdapter } from '@/configuration';
import { getFunctionsOnContext } from '@/constants';

export async function getBotInfo(params) {
  try {
    return await DatabaseAdapter.callCloudFunction(getFunctionsOnContext().GET_BOT_INFO, params)
  }
   catch (error) {
    Promise.reject()
    
  }
}